import * as analytics from 'analytics/Analytics';
import {assert} from 'Asserts';
import {EventConstants} from 'constants/EventConstants';
import AppDispatcher, {FluxAction} from 'lib/Dispatcher';
import Store from 'lib/Store';
import * as NewUserFlowConstants from 'onboarding/new-user-flow/NewUserFlowConstants';

import {ALL_SCREENS, isInScreenSubset, Screen} from './FullScreenConstants';

class FullScreenStore extends Store {
  currentScreen: Screen | null = null;

  resetState(): void {
    this.currentScreen = null;
  }

  getCurrentScreen(): Screen | null {
    return this.currentScreen;
  }

  isNewUserFlowActive(): boolean {
    return isInScreenSubset(this.currentScreen, NewUserFlowConstants.ALL_SCREENS);
  }

  showScreen(screen: Screen, flow: string | null = null): void {
    assert(ALL_SCREENS.includes(screen), `Unsupported full screen shown: ${screen}`);
    const previousScreen = this.currentScreen;

    this.currentScreen = screen;
    this.emitChange();
    analytics.track('full_screen', 'viewed_screen', {
      flow,
      previousScreen,
      screen,
    });
  }

  hideScreen(): void {
    const previousScreen = this.currentScreen;
    this.resetState();
    this.emitChange();

    if (previousScreen) {
      analytics.track('full_screen', 'hid_screen', {
        screen: previousScreen,
      });
    }
  }

  payloadHandler(action: FluxAction): boolean {
    switch (action.actionType) {
      case EventConstants.SHOW_FULL_SCREEN: {
        this.showScreen(action.screen);
        break;
      }
      case EventConstants.HIDE_FULL_SCREEN: {
        this.hideScreen();
        break;
      }
      default: {
        break;
      }
    }
    return true;
  }
}

export default new FullScreenStore(AppDispatcher);
